<div class="overlay" (click)="onBack()" [@fadeAnimation]></div>

<div class="sidepane-content">
  <div class="flex-space-between-layout template-header">
    <h1>Change Password</h1>
    <hf-custom-button type="button" [class]="'square-btn btn-clear'" icon="close" iconPos="center" (onClick)="onBack()">
    </hf-custom-button>
  </div>

  <form [formGroup]="changePassFG" novalidate (ngSubmit)="onSubmit()">
    <div class="template-main">
      <input type="text" id="username" name="username" autocomplete="username" [value]="email" aria-hidden="true"
        style="position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; border: 0; overflow: hidden; clip: rect(0 0 0 0); clip-path: inset(50%); white-space: nowrap;" />

      <label
        >Current Password
        <hf-custom-text-field
          type="password"
          [group]="changePassFG"
          inputFormControlName="currentPassword"
          fieldName="currentPassword"
          autocomplete="current-password"
          marginElement
          validateOnBlur
        >
        </hf-custom-text-field>
      </label>

      <label
        >New Password
        <hf-custom-text-field
          type="password"
          [group]="changePassFG"
          inputFormControlName="newPassword"
          fieldName="newPassword"
          autocomplete="new-password"
          marginElement
          validateOnBlur
        >
        </hf-custom-text-field>
      </label>

      <label
        >Confirm New Password
        <hf-custom-text-field
          type="password"
          [group]="changePassFG"
          inputFormControlName="newPasswordRep"
          autocomplete="new-password"
          fieldName="newPasswordRep"
          marginElement
          validateOnBlur
        >
        </hf-custom-text-field>
      </label>

      <hfc-password-requirements [control]="changePassFG.get('newPassword')"></hfc-password-requirements>

      <div
        *ngIf="changePassFG.get('newPasswordNotValid').invalid && changePassFG.get('newPasswordRep').touched"
        class="error-message"
      >
        Passwords don't match
      </div>

      <div *ngIf="notValidPassword == changePassFG.get('currentPassword').value" class="error-message">
        Current password is incorrect
      </div>

      <div *ngIf="serverError" class="error-message">{{ serverMessage }}</div>
    </div>

    <div class="template-footer">
      <hf-custom-button
        type="submit"
        class="button-primary btn-md"
        label="Submit"
        [disabled]="submitted || changePassFG.invalid"
        [allowNativeSubmit]="true"
      >
      </hf-custom-button>

      <hf-custom-button type="button" class="button-grey btn-md" label="Cancel" (click)="onBack()">
      </hf-custom-button>
    </div>
  </form>
</div>
